import { render } from "./RegistrationPanel.vue?vue&type=template&id=a9cbe528&scoped=true"
import script from "./RegistrationPanel.vue?vue&type=script&lang=ts"
export * from "./RegistrationPanel.vue?vue&type=script&lang=ts"

import "./RegistrationPanel.vue?vue&type=style&index=0&id=a9cbe528&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9cbe528"

export default script